/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import { store } from '../store/store'
import { cartApis } from '../services/ApiServices/cartApis'

export const sharedCartMethods = new Vue({
	methods: {
		insertCartApiChooser () {
			if (store.getters['cart/getCartCount'] > 0) {
				cartApis.insertCart()
			} else {
				cartApis.clearCart()
			}
		}
	}
})
